let devices = undefined;
let loadingDevices = false;
let selectedDevice;

export const needUserSelectPrinter = async (label) => {
    try {
        // Refresh the list of devices.
        if (!devices) 
            await loadDevices();
        if (devices.length < 1) 
            return false; // this should cause an error message.

        // See if the desired label width has a configuration available
        let labelWidthConfig = getLabelWidthConfig();
        let width = label['label-width'];
        for (let i = 0; i < devices.length; i++) {
            let deviceUUID = devices[i]['uid'];
            if (deviceUUID in labelWidthConfig['printers']) {
                if (labelWidthConfig['printers'][deviceUUID] === width) {
                    return false;
                }
            }
        }
        return true;
    }
    catch (error) {
        // no printers to ask the user to select from.
        console.log("BrowserPrint Error: " + error.message);
        return false;
    }
}

export const getLabelPrinterDevices = () => {
    return devices;
}

export const setPrinterWidthConfig = (labelWidth, deviceUUID) => {
    try {
        let labelWidthConfig = getLabelWidthConfig();

        if (!deviceUUID) return;

        // Make sure the printer UUID only apears once in the config
        if (deviceUUID in labelWidthConfig['printers']) {
            delete labelWidthConfig['printers'][deviceUUID];
        }
        labelWidthConfig['printers'][deviceUUID] = labelWidth;
        setLabelWidthConfig(labelWidthConfig);
    }
    catch (error) {
        // no printers to ask the user to select from.
        console.log("BrowserPrint Error: " + error.message);
    }
}

export const selectPrinter = (label) => {
    try {
        let width = label['label-width'];
        let labelWidthConfig = getLabelWidthConfig();

        // If there are no devices, exit out without setting a printer
        if (!devices) return false;
        if (devices.length < 1) return false;

        for (let i = 0; i < devices.length; i++) {
            let deviceUUID = devices[i]['uid'];
            if (deviceUUID in labelWidthConfig['printers']) {
                if (labelWidthConfig['printers'][deviceUUID] === width) {
                    selectedDevice = devices[i];
                    return true;
                }
            }
        }
        // Unable to select a device (Shouldn't get here in normal
        // execution.)
        return false;
    }
    catch (error) {
        // no printers to ask the user to select from.
        console.log("BrowserPrint Error: " + error.message);
        return false;
    }
}

// Delay left between two labels so the printer buffer has time to breathe
// when a whole level of bins is sent at once.
const BULK_PRINT_DELAY_MS = 150;

export const printZebraLabels = async (labels) => {
    if (!labels || labels.length < 1) {
        return {"status": 400, "message": "No label to print."};
    }

    for (let i = 0; i < labels.length; i++) {
        let status = printZebraLabel(labels[i]);
        if (status['status'] !== 200) {
            return status;
        }
        if (i < labels.length - 1) {
            await sleep(BULK_PRINT_DELAY_MS);
        }
    }
    return {"status": 200, "message": "OK"};
}

export const printZebraLabel=(label) => {

    console.log(JSON.stringify(label));
    // 1. Get the existing label printer config from the state
    try {
        // Assume that the device is selected.
        // This should happen at a higher level.

        // 1. Wait for the printer to be ready - Timout = error.
        // 2. Send the template to the printer.
        writeToSelectedPrinter(label['template']);
        // 3. Wait for the printer to be ready - Timout = error.
        // 4. Send the data to the printer.
        writeToSelectedPrinter(label['data']);
        // 5. Check if there was an error from the printer
        //    If the printer reports an error, inform the user via error message.
        // 6. Report success.
        return {"status": 200, "message":"OK"};
    }
    catch (error) {
        return {"status": 400, "message": "Label printer error: " + error.message}
    }
}

function getLabelWidthConfig() {
    let ls = window.localStorage;
    let labelWidthConfig = ls.getItem("label-width-config");
    if (!labelWidthConfig) {
        // Deal with no label width config stored
        labelWidthConfig = {};
    } else {
        labelWidthConfig = JSON.parse(labelWidthConfig);
    }
    // The following makes sure the old system gets replaced.
    if (!("printers" in labelWidthConfig)) {
        labelWidthConfig = {"printers": {}};
        setLabelWidthConfig(labelWidthConfig);
    }
    return labelWidthConfig;
}

function setLabelWidthConfig(labelWidthConfig) {
    let ls = window.localStorage;
    // Deal with no label width config stored
    if (!labelWidthConfig) {
        labelWidthConfig = {"printers": {}};
    }
    ls.setItem("label-width-config", JSON.stringify(labelWidthConfig));
}

async function loadDevices() {
    loadingDevices = true;
    window.BrowserPrint.getDefaultDevice("printer", function(device)
    {
        // Note: we don't actually care about the default device
        // Discover all the other devices available to the application
        window.BrowserPrint.getLocalDevices(function(device_list){
            devices = [];
            for(let i = 0; i < device_list.length; i++)
            {
                let device = device_list[i];
                if(device.uid)
                {
                    devices.push(device);
                }
            }
            if (devices.length > 0)
                selectedDevice = device[0];
            loadingDevices = false
        }, function(error){
            loadingDevices = false
            throw(error);
        } ,"printer");
        
    }, function(error){
        loadingDevices = false
        throw(error);
    });
    while (loadingDevices) {
        await sleep(20);
    }
}

function writeToSelectedPrinter(dataToWrite)
{
    if (selectedDevice) {
	    selectedDevice.send(dataToWrite, undefined, errorCallback);
    } else {
        throw(new Error("No label printer detected."));
    }
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// var readCallback = function(readData) {
// 	if(readData === undefined || readData === null || readData === "")
// 	{
// 		alert("No Response from Device");
// 	}
// 	else
// 	{
// 		alert(readData);
// 	}
	
// }

var errorCallback = function(errorMessage){
	console.log("BrowserPrint Error: " + errorMessage);	
}

// function readFromSelectedPrinter()
// {
// 	selectedDevice.read(readCallback, errorCallback);
// }

